import { render, staticRenderFns } from "./FacebookImage.vue?vue&type=template&id=0564545c&scoped=true"
import script from "./FacebookImage.vue?vue&type=script&lang=js"
export * from "./FacebookImage.vue?vue&type=script&lang=js"
import style0 from "./FacebookImage.vue?vue&type=style&index=0&id=0564545c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0564545c",
  null
  
)

export default component.exports